angular.module('stwo.glue', ["stwo.core", "ui.bootstrap", "angularMoment", "ngAudio"])
  .constant('angularMomentConfig', {
    preprocess: 'utc',
    timezone: jstz.determine().name() // e.g. 'Europe/London'
  })
  .config(function ($stateProvider, $urlRouterProvider, moduleStoreProvider) {

    setTimeout(function (i) {
        console.log('=== Reloading AM after 1 hour ===')
        window.location.reload();
    }, 1000 * 60 * 30);

    moduleStoreProvider.states().missingCustomer = "secure.user";
    moduleStoreProvider.states().notLoggedIn = "login.box";

    $urlRouterProvider.otherwise("/login");

    $stateProvider
      .state("login", {
        url: "/",
        abstract: true,
        views: {
          "loginheader": {
            templateUrl: "glue/login/header.html"
          },
          'logincontent': {
            templateUrl: "glue/login/content.html"
          }
        }
      })

      .state('login.box', {
        url: "login",
        views: {
          'logincontent@': {
            templateUrl: 'glue/login/views/login.html'
          }
        },
        menu: {
          name: 'Login',
          tag: "main"
        }
      })

      .state("login-with-credentials", {
        url: "login/:username/:password",
        views: {
          'logincontent@': {
            templateUrl: 'glue/login/views/login.html'
          }
        }
      })

      .state('login.demo', {
        url: "demo",
        views: {
          'logincontent@': {
            templateUrl: 'glue/login/views/demo.html'
          }
        },
        menu: {
          name: 'Demo',
          tag: 'main'
        }
      })

      .state('login.contact', {
        url: "contact",
        views: {
          'logincontent@': {
            templateUrl: 'glue/login/views/contact.html'
          }
        },
        menu: {
          name: 'Contact',
          tag: 'main'
        }
      })

      .state("login.logout", {
        url: "logout/:reason",
        views: {
          'logincontent@': {
            templateUrl: 'glue/login/views/login.html',
            controller: "LogoutController"
          }
        }
      })
      .state("secure", {
        url: "/secure",
        templateUrl: "glue/secure.html",
        controller: "SecureController"
      })
      .state("secure.notifications", {
        url: "/notifications",
        templateUrl: "glue/notifications/list.html",
        controller: "NotificationController"
      })
      .state("secure.content", {
        url: "/content",
        templateUrl: "glue/welcome.html",
        controller: "ContentController"
      })
      .state("secure.user", {
        url: "/user",
        templateUrl: "glue/user/user.html",
        controller: "UserController"
      })
  })
  .config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: stwoGlobal.languageUrl,
      suffix: '.json?x=812746'
    });

    $translateProvider.preferredLanguage(localStorage["language"] && _.find(stwoGlobal.availableLanguages, function (lang) {
      return localStorage["language"] === lang.code;
    }) ? localStorage["language"] : stwoGlobal.defaultLanguage);
  }]);


angular.module('stwo.glue').run(["$rootScope", "$anchorScroll", function ($rootScope, $anchorScroll) {
  $rootScope.$on("$locationChangeSuccess", function () {
    $anchorScroll();
  });
}]);

angular.module('stwo.glue').controller('SecureController', function ($translate, $timeout, $window, $rootScope, $scope, $state, $modal, pushService, timerService, smarttrackerService, socketioService, notificationService, moduleStore, ngAudio) {


  // new push
  var createSoundFilter = function () {
    var sf = {};
    sf[getSoundName($scope.soundData.redAlarmSound)] = "severity:equals=high";
    var n = getSoundName($scope.soundData.greenAlarmSound);
    sf[n] = sf[n] ? 'OR( ' + sf[n] + "; severity:equals=low )" : "severity:equals=low";
    n = getSoundName($scope.soundData.orangeAlarmSound);
    sf[n] = sf[n] ? (sf[n].indexOf('OR(') == 0 ? sf[n].replace(' )', '; severity:equals=normal; )') : 'OR( ' + sf[n] + '; severity:equals=normal; )') : "severity:equals=normal";
    // sf[getSoundName($scope.soundData.greenAlarmSound)] =
    // sf[getSoundName($scope.soundData.greenAlarmSound)] = "severity:equals=low";
    // sf[getSoundName($scope.soundData.orangeAlarmSound)] = "severity:equals=normal";
    return sf;
  }

  var getSoundName = function (sound) {
    var ss = sound.sound.file;
    return sound.muted ? 'silence.wav' : (ss.substring(ss.lastIndexOf("/") + 1, ss.indexOf(".mp3")).toLowerCase() + ".wav");
  }

  $rootScope.checkToken = function () {

    if (stwoPushNotificationInfo === null) {

      //$window.alert("checktoken delayed");
      return $timeout(function () {

        $rootScope.checkToken();

      }, 1000);

    }

    $rootScope.newPushEnabled = true;

    if (smarttrackerService.getCustomerId()) {
      smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/pushSubscription?select=token+customer+soundFilter").then(function (response) {
        $rootScope.newPushTokens = response.data.result;
        $rootScope.newPushActive = false;
        if (stwoPushNotificationInfo) {
          delete stwoPushNotificationInfo.id
          for (var i in response.data.result) {
            var sub = response.data.result[i];
            //$window.alert("Sub " + i + ":\n\n" + JSON.stringify(sub));
            if (sub.token == stwoPushNotificationInfo.token && (sub.customer == null || smarttrackerService.getCustomerId() == sub.customer.id)) {
              $rootScope.newPushActive = true;
              stwoPushNotificationInfo.id = sub.id;
              //DEBUG//$window.alert("Push active with id " + stwoPushNotificationInfo.id);
              break;
            }

          }
        }
        //DEBUG//$window.alert("checkToken Done");
        $rootScope.newPushWorking = false;
      }, function (errorResp) {
        $window.alert("checktoken failed: " + errorResp);
        $rootScope.newPushWorking = false;
      });
    }
  }

  $translate(['PUSH_OFF', 'PUSH_ON']).then(function (translations) {
    $rootScope.enablePush = translations.PUSH_ON;
    $rootScope.disablePush = translations.PUSH_OFF;
  });

  $rootScope.newPushDebugInfo = JSON.stringify(stwoPushNotificationInfo);
  $rootScope.newPushEnabled = stwoPushNotificationInfo ? true : false;
  $rootScope.newPushActive = false;
  $rootScope.newPushWorking = false;
  $rootScope.newPushTokens = [];

  var enablePushLink = "smarttrackermobile:enablePush:" + smarttrackerService.getAuthToken() + ":" + smarttrackerService.getCustomerId();
  var disablePushLink = "smarttrackermobile:disablePush";

  var ua = $window.navigator.userAgent.toLowerCase();

  $rootScope.isAndroid = /android/.test(ua);
  $rootScope.isXguard = /xguard/.test(ua);
  $rootScope.isIOS = /iphone|ipod|ipad/.test(ua);
  $rootScope.isIOSApp = !/safari/.test(ua); //$window.navigator.standalone;

  $rootScope.pushEnabled = smarttrackerService.isPushSubscriptionEnabled();
  $rootScope.btnCaption = $scope.pushEnabled ? $scope.disablePush : $scope.enablePush;
  $translate(['XGUARD_USER_PUSH_OFF', 'XGUARD_USER_PUSH_ON']).then(function (translations) {
    $rootScope.enablePush = translations['XGUARD_USER_PUSH_ON'];
    $rootScope.disablePush = translations['XGUARD_USER_PUSH_OFF'];
    $rootScope.btnCaption = $scope.pushEnabled ? $scope.disablePush : $scope.enablePush;

  });

  $rootScope.useragent = $window.navigator.userAgent;
  //$scope.displayPushButton = $scope.userAgent.indexOf('iPhone')

  $rootScope.togglePush = function () {
    smarttrackerService.togglePushSubscription();
    $rootScope.pushEnabled = smarttrackerService.isPushSubscriptionEnabled();
    $rootScope.btnCaption = $rootScope.pushEnabled ? $rootScope.disablePush : $rootScope.enablePush;
    window.location = $rootScope.pushEnabled ? disablePushLink : enablePushLink;
    console.log($rootScope.btnCaption);
  }

  $rootScope.toggleNewPush = function () {

    //DEBUG//$window.alert('Toggle started\n'+JSON.stringify(stwoPushNotificationInfo))

    $rootScope.newPushWorking = true;
    if ($rootScope.newPushActive) {

      if (stwoPushNotificationInfo === null) {
        //DEBUG//$window.alert('Trying to disable but push Notifications are not enabled for your device.')
        return;
      }

      if (typeof stwoPushNotificationInfo.id === 'undefined') {

        $rootScope.checkToken();
        setTimeout(function () {

          $rootScope.toggleNewPush();

        }, 1000)
        return;

      }

      stwoPushNotificationInfo.customer = {
        "id": smarttrackerService.getCustomerId()
      };

      //DEBUG//$window.alert("stwoPushNotificationInfo\n\n" +JSON.stringify(stwoPushNotificationInfo))

      smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/pushSubscription/" + stwoPushNotificationInfo.id)
        .then(function (response) {
          delete stwoPushNotificationInfo.id;
          $rootScope.checkToken();
        }, function (errorResponse) {

          $rootScope.checkToken();
          //DEBUG//$window.alert('Delete failed: '+JSON.stringify(errorResponse))


        });
    } else {

      if (stwoPushNotificationInfo === null) {
        //DEBUG//$window.alert('Push Notifications are not enabled for your device.')
        return;
      }

      //  var rs = $scope.soundData.redAlarmSound.sound.file;
      // var gs = $scope.soundData.greenAlarmSound.sound.file;
      // var os = $scope.soundData.orangeAlarmSound.sound.file;
      // rs = getSoundName(rs) + ".wav";
      // gs = getSoundName(gs) + ".wav";
      // os = getSoundName(os) + ".wav";
      if (stwoPushNotificationInfo.labels && stwoPushNotificationInfo.labels["version"] && stwoPushNotificationInfo.labels["version"] == "2.0") {
        stwoPushNotificationInfo.soundFilter = createSoundFilter();
        console.log(stwoPushNotificationInfo);
        stwoPushNotificationInfo.labels["version"] = {
          value: stwoPushNotificationInfo.labels["version"]
        };
      }
      smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/pushSubscription/", stwoPushNotificationInfo)
        .then(function (response) {
          $rootScope.checkToken();
          //DEBUG//$window.alert('checking token after adding')
        }, function (errorResponse) {
          //DEBUG//$window.alert('error\n\n'+JSON.stringify(errorResponse))
          if (errorResponse.status == 409) {
            $rootScope.notificationError = true;
            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/pushSubscription/?overwriteIfExists=true", stwoPushNotificationInfo)
              .then(function (response) {
                //DEBUG//$window.alert('checking token after adding (overwrite)')
                $rootScope.checkToken();
              });
          }
        });
    }
  }

  $rootScope.checkToken();

  smarttrackerService.isLoggedInDelayed().then(function () {

    console.log('IS LOGGED IN DELAYED OK');

    $scope.userData = smarttrackerService.getUserData();

    $scope.$watch("userData.customer.id", function () {
      $rootScope.checkToken();
    })

    $scope.sounds = notificationService.getSounds();
    $scope.soundData = $scope.userData.user.preferences.meta ? $scope.userData.user.preferences.meta : {};
    $scope.soundData = notificationService.checkSoundData($scope.soundData);

    $rootScope.checkToken();

  }, function () {

    console.log('IS LOGGED IN DELAYED NOT OK: Logout');

    $state.go(moduleStore.states().notLoggedIn);
    return;
  });
  // end



  //adding underscore lib to scope
  $scope["_"] = _;

  $scope["hiddenUi"] = stwoGlobal.hiddenUi;

  $scope.modalContent = {
    images: []
  };
  $scope.openModalImages = function (imageUrlArr) {
    $scope.modalContent.images = imageUrlArr;
  }

  var lastMouseMove = (new Date()).getTime();
  $scope.inactivityState = {
    "enabled": false,
    "warning": false,
    "remaining": 12,
    "remainingPct": 0.6,
    "warningTime": 0
  };

  if (stwoGlobal.inactivityTimeout > 0) {
    $scope.inactivityState.enabled = true;
    $scope.inactivityState.warningTime = stwoGlobal.inactivityTimeout * (3 / 4);
    document.addEventListener(
      'mousemove',
      function () {
        lastMouseMove = (new Date()).getTime();
        if ($scope.inactivityState.warning) {
          $scope.inactivityState.warning = false;
        }
      },
      false
    );
  }


  smarttrackerService.isLoggedInDelayed().then(function () {

    // var socketioService = moduleStoreProvider.serviceRepository()["socketioService"];
    socketioService.connect();

    moduleStore.serviceRepository()["$state"] = $state;
    moduleStore.serviceRepository()["$modal"] = $modal;
    pushService.enabled(true);

    $scope.status = {
      menuOpen: false,
      notificationsOpen: false,
      settingsOpen: false
    };

    $scope.userData = smarttrackerService.getUserData();

    $scope.timers = timerService.timers();
    $scope.links = moduleStore.rootLinks();
    $scope.notifications = notificationService.undismissed();
    $scope.notificationsChanged = notificationService.changed;
    $scope.modules = moduleStore.modules();
    $scope.access = smarttrackerService.getAccessRights();
    $scope.customNotifications = notificationService.customNotifications();
    $scope.notificationTypes = notificationService.notificationTypes();
    console.log($scope.notificationTypes);

    $scope.customNotificationClicked = function (notification) {
      console.log("notification clicked", notification);
      console.log($scope.notificationTypes[notification.type]);
      console.log($scope.notificationTypes[notification.type].state);
      $state.go($scope.notificationTypes[notification.type].state);

      $scope.notificationCenter = false;
    }

    $scope.dismissCustomNotification = function (notification) {
      console.log("Dismiss notification");
      notificationService.dismissCustomNotification(notification);
      $scope.customNotifications = notificationService.customNotifications();
    }

    $scope.allLinks = moduleStore.links();
    $scope.categories = moduleStore.categories();

    $scope.rebuildLinksPerCategory = function () {
      $scope.linksPerCategory = {};
      $scope.navigationLinksPerCategory = {};
      $scope.navigationLinksCount = 0;
      $scope.categoriesWithLinks = 0;
      for (var n = 0; n < $scope.allLinks.length; n++) {
        var l = $scope.allLinks[n];

        if (!$scope.linksPerCategory[l.category]) {
          $scope.linksPerCategory[l.category] = [];
        }
        if (l.hasAccess(l, $scope.access)) {
          $scope.linksPerCategory[l.category].push(l);
          if (l.navigation) {
            if (!$scope.navigationLinksPerCategory[l.category]) {
              $scope.navigationLinksPerCategory[l.category] = [];
              $scope.categoriesWithLinks++;
            }
            $scope.navigationLinksPerCategory[l.category].push(l);
            $scope.navigationLinksCount++;
          }
        }
      }
    }

    $scope.rebuildLinksPerCategory();

    $scope.$watch("allLinks.length", function () {
      $scope.rebuildLinksPerCategory();
    })

    $scope.notificationAudio = notificationService.audio;

    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.updated + notificationsChanged.removed", function () {
      $scope.notifications = notificationService.undismissed();
      $scope.customNotifications = notificationService.customNotifications();
      checkAndPlayNotificationSound();
    })
    $scope.$watch("notificationsChanged.added", function (newVal, oldVal) {
      if (newVal) {
        $scope.notificationAudio.snoozed = false;
      }
    })

    $scope.toggleMute = function () {
      notificationService.audio.muted = !notificationService.audio.muted;
      localStorage["stwo-mute"] = notificationService.audio.muted;
    }
    $scope.toggleIgnoreSnooze = function () {
      notificationService.audio.ignoreSnooze = !notificationService.audio.ignoreSnooze;
      localStorage["stwo-ignore-snooze"] = notificationService.audio.ignoreSnooze;
    }

    $scope.stopPlayingNotificationAudio = function () {
      $scope.notificationAudio.snoozed = true;
    }

    var player = false;
    var playingFile = false;
    var play = function (color, file) {
      if (playingFile === file && player.remaining > 0) {
        return;
      }
      ngAudio.setUnlock(false);
      playingFile = file;
      if (player) {
        player.stop();
        player.unbind();
      }
      player = ngAudio.play(file);
    }

    var checkAndPlayNotificationSound = function () {
      if ($scope.notifications.length === 0) {
        $scope.notificationAudio.snoozed = false;
      }
      if (!notificationService.audio.muted && $scope.notifications.length) {
        var anyRedAlert = false;
        var anyOrangeAlerts = false;
        var anyGreenAlerts = false;
        var anyAlerts = false;
        var anyCPEvents = false;
        angular.forEach($scope.notifications, function (notification) {
          if (!notificationService.ignored[notification.id]) {
            if (notification.module == "alarm") {
              if (notification.level === "danger") {
                anyRedAlert = true;
              } else if (notification.level === "warning") {
                anyOrangeAlerts = true;
              } else if (notification.level === "success") {
                anyGreenAlerts = true;
              }
            } else if (notification.module == "cp") {
              anyCPEvents = true;
            }
          }
          anyAlerts = anyRedAlert || anyOrangeAlerts || anyGreenAlerts || anyCPEvents;
        });

        if (anyAlerts && (!notificationService.audio.snoozed || notificationService.audio.ignoreSnooze)) {
          var userData = smarttrackerService.getUserData();
          var soundData = notificationService.checkSoundData($scope.userData.user.preferences.meta ? $scope.userData.user.preferences.meta : {});

          if (anyRedAlert && !soundData.redAlarmSound.muted) {
            play("red", soundData.redAlarmSound.sound.file);
          } else if (anyOrangeAlerts && !soundData.orangeAlarmSound.muted) {
            play("orange", soundData.orangeAlarmSound.sound.file);
          } else if (anyGreenAlerts && !soundData.greenAlarmSound.muted) {
            play("green", soundData.greenAlarmSound.sound.file);
          } else if (anyCPEvents && !soundData.cpAlarmSound.muted) {
            play("cp", soundData.cpAlarmSound.sound.file);
          }
        }
      }
    }

    $scope.$watch("timers.one", function () {
      pushService.processNewPushMessages();
      checkAndPlayNotificationSound();

      if (stwoGlobal.inactivityTimeout > 0) {
        var now = (new Date()).getTime();
        if (now - lastMouseMove > stwoGlobal.inactivityTimeout * 1000) {
          console.log("Logged out because of inactivity")
          $state.go("logout", {
            reason: "LOGOUT_INACTIVITY_TIMEOUT"
          });
        } else if (now - lastMouseMove > $scope.inactivityState.warningTime * 1000) {
          if (!$scope.inactivityState.warning) {
            console.log("Inactivity warning")
          }
          $scope.inactivityState.warning = true;
          $scope.inactivityState.remaining = Math.round(((lastMouseMove + stwoGlobal.inactivityTimeout * 1000) - now) / 1000);
          $scope.inactivityState.remainingPct = $scope.inactivityState.remaining / (stwoGlobal.inactivityTimeout - $scope.inactivityState.warningTime);

        }
      }

    })

    $scope.viewNotification = function (notification) {
      notificationService.view(notification);
      $scope.status.notificationsOpen = false;
    }

    $scope.goToNotifications = function () {
      $scope.status.menuOpen = false;
      $state.go("secure.notifications");
    }

    $scope.$watch("timers.ten", function () {
      notificationService.poll();
    })


    $scope.pushChanged = pushService.changed();
    $scope.$watch("pushChanged.counter", function () {
      pushService.process(function (data, util) {
        notificationService.push(data, util);
      });
    })

    $scope.getSelectedCustomer = function () {
      var customer = smarttrackerService.getAvailableCustomers()[index];
      if (customer && (!$scope.selectedCustomer || $scope.selectedCustomer.id !== customer.id)) {
        for (var index in smarttrackerService.getAvailableCustomers()) {
          if (customer.id == smarttrackerService.getCustomerId()) {
            $scope.selectedCustomer = customer;
            break;
          }
        }
      }
      return $scope.selectedCustomer;
    }
    $scope.getSelectedProvider = function () {
      if (!$scope.selectedProvider) {
        for (var index in smarttrackerService.getAvailableProviders()) {
          var provider = smarttrackerService.getAvailableProviders()[index];
          if (provider.id === smarttrackerService.getProviderId()) {
            $scope.selectedProvider = provider;
            break;
          }
        }
      }
      return $scope.selectedProvider;
    }

    $scope.getActiveControllerName = function () {
      return $state.current.controller;
    }

    $scope.getTitleName = function () {
      return $state.current.titleName;
    }

    $scope.getTitleIcon = function () {
      return $state.current.titleIcon;
    }

    $scope.getParentControllerName = function () {
      return $state.$current.parent.controller;
    }

    $scope.getCurrentState = function () {
      return $state.current.name;
    }

    $scope.getBodyClass = function () {
      return $state.current.bodyclass;
    }

    $scope.checkCurrentState = function () { //true if it is among the arguments
      for (var i = 0; i < arguments.length; i++) {
        if ($state.current.name == arguments[i]) return true;
      }
      return false;
    }

    $scope.linkClicked = function (link) {
      $scope.status.menuOpen = false;
      if (link.stateParams) {
        $state.go(link.sref.split("(")[0], link.stateParams);
      } else {
        $state.go(link.sref);
      }
    }

    $scope.currentVersion = stwoGlobal.appVersion;
    $scope.beta = stwoGlobal.beta;

    if (!localStorage["localVersion"] && (localStorage["SidebarMap"] != null)) {
      localStorage["localVersion"] = $scope.currentVersion;
      localStorage["updateNotification"] = true;
      $scope.showUpdateNotification = true;
    }

    if (!localStorage["localVersion"]) {
      localStorage["localVersion"] = $scope.currentVersion;
      localStorage["updateNotification"] = false;
      $scope.showUpdateNotification = false;
    }

    if (localStorage["localVersion"] != $scope.currentVersion) {
      localStorage["localVersion"] = $scope.currentVersion;
      localStorage["updateNotification"] = true;
      $scope.showUpdateNotification = true;
    }

    if (localStorage["updateNotification"] == 'true') {
      $scope.showUpdateNotification = true;
    }

    $scope.closeUpdateNotification = function () {
      localStorage["updateNotification"] = false;
      $scope.showUpdateNotification = false;
    }


  }, function () {
    $state.go(moduleStore.states().notLoggedIn);
    return;
  });


});
angular.module('stwo.glue').controller('ContentController', function ($scope, $state, smarttrackerService, moduleStore) {
  smarttrackerService.isLoggedInDelayed().then(function () {
    if (!smarttrackerService.getCustomerId()) {
      $state.go(moduleStore.states().missingCustomer);
      return;
    }
  });
});
angular.module('stwo.glue').controller('UserController', function ($rootScope, $scope, $state, smarttrackerService, mapService, moduleStore, $translate, $window, ngAudio, utilService, notificationService) {

  $scope.state = {
    tab: "settings"
  };
  $scope.selected = {};

  // $translate(['PUSH_OFF', 'PUSH_ON']).then(function (translations) {
  //     $scope.enablePush = translations.PUSH_ON;
  //     $scope.disablePush = translations.PUSH_OFF;
  // });

  // $scope.newPushEnabled = stwoPushNotificationInfo?true:false;
  // $scope.newPushActive = false;
  // $scope.newPushWorking = false;
  // $scope.newPushTokens = [];

  smarttrackerService.isLoggedInDelayed().then(function () {
    // checkToken();
    $scope.fieldsPerView = 7;
    readInvitations();
  });

  var readInvitations = function () {
    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/userInvitation?select=customer&type:equals=customer&status:equals=pending").then(function (response) {
      $scope.invitations = response.data.result;
    });
  }
  $scope.updateInvitation = function (invitation, status) {
    console.log("Will update invitation");
    invitation.status = status;
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/userInvitation/" + invitation.id, {
      status: status
    }).then(function () {
      readInvitations();
      notificationService.dismissCustomNotifiactionsForObject(invitation);
    });
  }

  $scope.showMoreCustomers = function () {
    $scope.fieldsPerView += 10;
  }
  $scope.showAllCustomers = function () {
    $scope.fieldsPerView = $scope.availableCustomers.length;
  }

  $scope.availableCustomers = smarttrackerService.getAvailableCustomers();
  $scope.availableProviders = smarttrackerService.getAvailableProviders();

  $scope.availableMapProviders = mapService.getAvailableLayers();

  // var enablePushLink = "smarttrackermobile:enablePush:" + smarttrackerService.getAuthToken() + ":" + smarttrackerService.getCustomerId();
  // var disablePushLink = "smarttrackermobile:disablePush";

  // var ua = $window.navigator.userAgent.toLowerCase();

  // $scope.isAndroid = /android/.test(ua);
  // $scope.isXguard = /xguard/.test(ua);
  // $scope.isIOS = /iphone|ipod|ipad/.test(ua);
  // $scope.isIOSApp = !/safari/.test(ua);//$window.navigator.standalone;

  // $scope.pushEnabled = smarttrackerService.isPushSubscriptionEnabled();
  // $scope.btnCaption = $scope.pushEnabled ? $scope.disablePush : $scope.enablePush;
  // $translate(['XGUARD_USER_PUSH_OFF', 'XGUARD_USER_PUSH_ON']).then(function (translations) {
  //     $scope.enablePush = translations['XGUARD_USER_PUSH_ON'];
  //     $scope.disablePush = translations['XGUARD_USER_PUSH_OFF'];
  //     $scope.btnCaption = $scope.pushEnabled ? $scope.disablePush : $scope.enablePush;

  // });

  // $scope.useragent = $window.navigator.userAgent;
  //$scope.displayPushButton = $scope.userAgent.indexOf('iPhone')

  // $scope.togglePush = function () {
  //     smarttrackerService.togglePushSubscription();
  //     $scope.pushEnabled = smarttrackerService.isPushSubscriptionEnabled();
  //     $scope.btnCaption = $scope.pushEnabled ? $scope.disablePush : $scope.enablePush;
  //     window.location = $scope.pushEnabled ? disablePushLink : enablePushLink;
  //     console.log($scope.btnCaption);
  // }

  $scope.openDialog = "";
  $scope.openSoundSelector = function (color) {
    $scope.openDialog = color;
  }

  $scope.closeAudioSelector = function ($event) {
    var cl = $event.target.classList;
    if ($event.target.id != $scope.openDialog && !cl.contains("sound")) {
      $scope.openDialog = "";
      $scope.activeSound = null;
      if (audio) {
        audio.stop();
        audio.unbind();
      }
    }
  };

  var audio = false;
  $scope.selectSound = function (sound, color) {
    // var data = utilService.clone($scope.soundData);
    // data[color + "AlarmSound"].sound = sound;
    // updateSoundPrefs(data);
    $scope.activeSound = sound;
    if (audio) {
      audio.stop();
      audio.unbind();
    }
    ngAudio.setUnlock(false);
    audio = ngAudio.load(sound.file);
    audio.play();
  }

  $scope.saveSound = function (color) {
    var data = {};
    angular.forEach($scope.soundData, function (value, key) {
      data[key] = utilService.clone(value);
    });
    if ($scope.soundData[color + "AlarmSound"].sound.file == $scope.activeSound.file) {
      return;
    }
    data[color + "AlarmSound"].sound = $scope.activeSound;
    updateSoundPrefs(data);
    $('.toggle-sounds').parent().removeClass('open');
    $scope.activeSound = null;
  }

  var updatePushSound = function () {
    angular.forEach($scope.newPushTokens, function (token, key) {
      if (token.soundFilter && Object.keys(token.soundFilter).length > 0) {
        var body = {
          'soundFilter': createSoundFilter()
        }
        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/pushSubscription/" + token.id, body);
      }
    })
  }

  var updateSoundPrefs = function (data) {
    $scope.soundDataUpdating = true;
    var body = {
      "user": {
        "preferences": {
          "meta": data
        }
      }
    };
    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/index", body).then(function (response) {
      console.log("ALLES IN ORDNUNG");
      $scope.userData.user.preferences.meta = response.data.user.preferences.meta;
      $scope.soundData = notificationService.checkSoundData($scope.userData.user.preferences.meta);
      $scope.soundDataUpdating = false;
      updatePushSound();
    }, function () {
      console.log("Nicht So Gut :(");
      $scope.soundDataUpdating = false;
    });
  }
  $scope.toggleMuted = function (color) {
    var data = utilService.clone($scope.soundData);
    data[color + "AlarmSound"].muted = !data[color + "AlarmSound"].muted;
    updateSoundPrefs(data);
  }

  var getSoundName = function (sound) {
    var ss = sound.sound.file;
    return sound.muted ? 'silence.wav' : (ss.substring(ss.lastIndexOf("/") + 1, ss.indexOf(".mp3")).toLowerCase() + ".wav");
  }

  var createSoundFilter = function () {
    var sf = {};
    sf[getSoundName($scope.soundData.redAlarmSound)] = "severity:equals=high";
    var n = getSoundName($scope.soundData.greenAlarmSound);
    sf[n] = sf[n] ? 'OR( ' + sf[n] + "; severity:equals=low )" : "severity:equals=low";
    n = getSoundName($scope.soundData.orangeAlarmSound);
    sf[n] = sf[n] ? (sf[n].indexOf('OR(') == 0 ? sf[n].replace(' )', '; severity:equals=normal; )') : 'OR( ' + sf[n] + '; severity:equals=normal; )') : "severity:equals=normal";
    // sf[getSoundName($scope.soundData.greenAlarmSound)] =
    // sf[getSoundName($scope.soundData.greenAlarmSound)] = "severity:equals=low";
    // sf[getSoundName($scope.soundData.orangeAlarmSound)] = "severity:equals=normal";
    return sf;
  }

  // $scope.toggleNewPush = function() {
  //     $scope.newPushWorking = true;
  //     if($scope.newPushActive){
  //         stwoPushNotificationInfo.customer = {"id":smarttrackerService.getCustomerId()};
  //         smarttrackerService.authDelete(smarttrackerService.getCustomerId() + "/pushSubscription/" + stwoPushNotificationInfo.id)
  //             .then(function (response){
  //                 delete stwoPushNotificationInfo.id;
  //                 checkToken();
  //             });
  //     } else {
  //         //  var rs = $scope.soundData.redAlarmSound.sound.file;
  //         // var gs = $scope.soundData.greenAlarmSound.sound.file;
  //         // var os = $scope.soundData.orangeAlarmSound.sound.file;
  //         // rs = getSoundName(rs) + ".wav";
  //         // gs = getSoundName(gs) + ".wav";
  //         // os = getSoundName(os) + ".wav";
  //         if(stwoPushNotificationInfo.labels&&stwoPushNotificationInfo.labels["version"]&&stwoPushNotificationInfo.labels["version"]=="2.0") {
  //             stwoPushNotificationInfo.soundFilter = createSoundFilter();
  //             console.log(stwoPushNotificationInfo);
  //             stwoPushNotificationInfo.labels["version"] = {value:stwoPushNotificationInfo.labels["version"]};
  //         }
  //         smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/pushSubscription/", stwoPushNotificationInfo)
  //             .then(function (response){
  //                 checkToken();
  //             }, function (errorResponse){
  //                 if(errorResponse.status == 409) {
  //                     $scope.notificationError = true;
  //                     smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/pushSubscription/?overwriteIfExists=true", stwoPushNotificationInfo)
  //                     .then(function (response){
  //                         checkToken();
  //                     });       
  //                 }
  //             });
  //     }
  // }

  // var checkToken = function() {
  //     if(smarttrackerService.getCustomerId()) {
  //         smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/pushSubscription?select=token+customer+soundFilter").then(function (response){
  //             $scope.newPushTokens = response.data.result;
  //             $scope.newPushActive = false;
  //             if(stwoPushNotificationInfo){
  //                 delete stwoPushNotificationInfo.id
  //                 for(var i in response.data.result){
  //                     var sub = response.data.result[i];
  //                     if(sub.token == stwoPushNotificationInfo.token && (sub.customer == null || smarttrackerService.getCustomerId() == sub.customer.id)){
  //                         $scope.newPushActive = true;
  //                         stwoPushNotificationInfo.id = sub.id;
  //                         break;
  //                     }

  //                 }
  //             }
  //             $scope.newPushWorking = false;
  //         }, function(errorResp){
  //             alert("failed: " + errorResp);
  //             $scope.newPushWorking = false;
  //         });
  //     }
  // }


  $scope.getCurrentCustomerId = function () {
    return smarttrackerService.getCustomerId();
  }
  $scope.selectedCustomerIndex = 0;
  $scope.customerName = '';

  $scope.customerSearch = function ($event, maxSearch, customerId) {
    if ($scope.customerName == '') return;
    var keyCode = $event.which || $event.keyCode;
    if (keyCode === 13) {
      console.log(customerId);
      if (customerId) {
        $scope.chooseCustomer(customerId);
      }
    } else if (keyCode == 38 /*UpArrow*/ ) {
      if ($scope.selectedCustomerIndex > 0) $scope.selectedCustomerIndex--;
    } else if (keyCode == 40 /*Down Arrow*/ ) {
      $scope.selectedCustomerIndex = Math.min(maxSearch - 1, $scope.selectedCustomerIndex + 1);
    } else {
      $scope.selectedCustomerIndex = 0;
    }
  }

  $scope.getCurrentCustomerName = function () {
    if (smarttrackerService.getCustomerId()) {
      for (var n = 0; n < $scope.availableCustomers.length; n++) {
        if ($scope.availableCustomers[n].id === smarttrackerService.getCustomerId()) {
          return $scope.availableCustomers[n].name;
        }
      }
      return null;
    } else {
      return null;
    }
  }

  $scope.getCurrentProviderId = function () {
    return smarttrackerService.getProviderId();
  }

  $scope.getCurrentProviderName = function () {
    if (smarttrackerService.getProviderId()) {
      for (var n = 0; n < $scope.availableProviders.length; n++) {
        if ($scope.availableProviders[n].id === smarttrackerService.getProviderId()) {
          return $scope.availableProviders[n].name;
        }
      }
      return null;
    } else {
      return null;
    }
  }

  $scope.customerSelectWorking = false;
  $scope.chooseCustomer = function (customerId) {
    if ($scope.customerSelectWorking || customerId == smarttrackerService.getCustomerId()) return;
    $scope.customerSelectWorking = true;
    smarttrackerService.changeCustomer(customerId).then(function (response) {
      $scope.customerSelectWorking = false;
    });
  }
  $scope.chooseProvider = function (providerId) {
    smarttrackerService.changeProvider(providerId);
  }

  $scope.availableLanguages = stwoGlobal.availableLanguages;


  $scope.mapDefaultStates = [{
    key: "auto",
    label: "MAP_DEFAULT_AUTO"
  }, {
    key: "indoor",
    label: "MAP_DEFAULT_INDOOR"
  }, {
    key: "outdoor",
    label: "MAP_DEFAULT_OUTDOOR"
  }]

  $translate(['MAP_DEFAULT_AUTO', 'MAP_DEFAULT_INDOOR', 'MAP_DEFAULT_OUTDOOR']).then(function (translations) {
    $scope.mapDefaultStates[0].label = translations.MAP_DEFAULT_AUTO;
    $scope.mapDefaultStates[1].label = translations.MAP_DEFAULT_INDOOR;
    $scope.mapDefaultStates[2].label = translations.MAP_DEFAULT_OUTDOOR;
  });

  smarttrackerService.isLoggedInDelayed().then(function () {
    for (var n = 0; n < stwoGlobal.availableLanguages.length; n++) {
      if (stwoGlobal.availableLanguages[n].code === smarttrackerService.language()) {
        $scope.selected["language"] = stwoGlobal.availableLanguages[n];
      }
    }
    if (!$scope.selected["language"]) {
      $scope.selected["language"] = stwoGlobal.availableLanguages[0];
    }
    $scope.selected["mapProvider"] = $scope.availableMapProviders[mapService.chosenLayer()];


    $scope.selected["mapDefaultState"] = $scope.mapDefaultStates[0];
    for (var n = 0; n < $scope.mapDefaultStates.length; n++) {
      if ($scope.mapDefaultStates[n].key === localStorage["mapDefaultState"]) {
        $scope.selected["mapDefaultState"] = $scope.mapDefaultStates[n];
      }
    }
    $scope.$watch("selected.mapDefaultState.key", function () {
      localStorage["mapDefaultState"] = $scope.selected["mapDefaultState"].key;
    });

    $scope.$watch("selected.language.code", function (newVal, oldVal) {
      if (oldVal && oldVal !== newVal) {
        console.log("Lang changed in user controller")

        smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/index', {
            user: {
              language: $scope.selected.language.code
            }
          })
          .then(function (response) {

          }, function (response) {

          });

        smarttrackerService.language($scope.selected["language"].code);
      }
    });
    $scope.$watch("selected.mapProvider.name", function () {
      mapService.chosenLayer($scope.selected["mapProvider"].code);
    });

    $scope.$watch("userData.customer.id", function () {
      $rootScope.checkToken();
    })
    $scope.sounds = notificationService.getSounds();
    $scope.soundData = $scope.userData.user.preferences.meta ? $scope.userData.user.preferences.meta : {};
    $scope.soundData = notificationService.checkSoundData($scope.soundData);

  }, function () {
    $state.go(moduleStore.states().notLoggedIn);
    return;
  });



});


angular.module('stwo.glue').controller('LogoutController', function ($scope, $state, $timeout, $stateParams, smarttrackerService, moduleStore) {
  smarttrackerService.logout();

  $timeout(function () {
    if ($stateParams.reason) {
      moduleStore.flags()["logoutReason"] = $stateParams.reason;
    } else {
      delete moduleStore.flags()["logoutReason"];
    }
    $state.go(moduleStore.states().notLoggedIn);
  }, 100);
});
angular.module('stwo.glue').controller('LoginController', function ($scope, $state, $http, $translate, moduleStore, $stateParams, smarttrackerService, notificationService, $timeout) {
	$scope.alerts = [];
    $scope.user = {};
    
    if (moduleStore.flags()["logoutReason"]) {
        $scope.alerts.push({type: "danger", textToTranslate: moduleStore.flags()["logoutReason"]});
    }
    
    $scope.login = {state: "login", language: null, working: false, rememberLogin: true, renewPassword: false, credentialsMode: true};

    $translate(['LOGIN_FORGOT_PASSWORD_MAIL_TEMPLATE']).then(function (translations) {
        $scope.login.mailTemplate = translations['LOGIN_FORGOT_PASSWORD_MAIL_TEMPLATE'];
    });
    
    $scope.availableLanguages = stwoGlobal.availableLanguages;
    for (var n = 0; n < stwoGlobal.availableLanguages.length; n++) {
        if (stwoGlobal.availableLanguages[n].code === smarttrackerService.language()) {
            $scope.login["language"] = stwoGlobal.availableLanguages[n];
        }
    }
    if (!$scope.login["language"]) {
        $scope.login["language"] = stwoGlobal.availableLanguages[0];
    }
    $scope.setLanguage = function(languageCode) {
        for (var n = 0; n < stwoGlobal.availableLanguages.length; n++) {
            if (stwoGlobal.availableLanguages[n].code === languageCode) {
                $scope.login["language"] = stwoGlobal.availableLanguages[n];
                smarttrackerService.language(languageCode);
            }
        }
    };
    
    console.log("Language", $scope.login["language"]);
        
	$scope.sendRecoveryMail = function(usernameToRecover) {
        
        $scope.login.working = true;
        $http.post(smarttrackerService.url() + "api2/passwordRecovery", {"action":"requestRecovery", "html": $scope.login.mailTemplate, "username": usernameToRecover}).then(function(response) {
                $scope.login.working = false;
                $scope.login.modalAlert = "LOGIN_FORGOT_PASSWORD_RECOVERY_REQUEST_SENT_TEXT"
            }, function() {
                $scope.login.working = false;
                $scope.login.modalAlert = "LOGIN_FORGOT_PASSWORD_RECOVERY_REQUEST_ERROR_TEXT"
        });
	};
	$scope.performRecovery = function(recoveryKey) {
        $scope.login.working = true;
        $http.post(smarttrackerService.url() + "api2/passwordRecovery", {"action":"performRecovery", "recoveryKey": recoveryKey}).then(function(response) {
                $scope.login.working = false;
                $scope.login.modalAlert = "LOGIN_FORGOT_PASSWORD_PASSWORD_RESET_SUCCESS_TEXT";
                $scope.login.credentialsMode = true;
                $scope.login.renewPassword = false;
                $scope.login.state = "login";
            }, function() {
                $scope.login.working = false;
                $scope.login.modalAlert = "LOGIN_FORGOT_PASSWORD_PASSWORD_RESET_ERROR_TEXT"
        });
	};
        
        
	$scope.cancelRenew = function() {
		$scope.login.renewPassword = false;
	}
	$scope.storedUsers = smarttrackerService.getUsers();
        
        $scope.login.credentialsMode = $scope.storedUsers.length == 0;
        $scope.$watch("storedUsers.length", function() {
            $scope.login.credentialsMode = !$scope.login.credentialsMode ? $scope.storedUsers.length == 0 : $scope.login.credentialsMode;
        });
	$scope.doLogout = function() {
		smarttrackerService.logout();
	}

	$scope.closeAlert = function (idx) {
		$scope.alerts.splice(idx, 1);
	}
	$scope.removeUser = function (username) {
		smarttrackerService.removeUser(username);
	}
	$scope.selectUser = function(username) {
		$scope.login.working = true;
		
		smarttrackerService.selectUser(username).then(function (response) {
                    if (!response||response.status!=200) {
                        
                        if (response.status == 402) {
                            $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_GETTING_INFO"});
                        } else if(response.data.tokenNotFound || response.data.tokenExpired || response.status == 401 ){
                            smarttrackerService.removeUser(username);
                            $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_AUTHENTICATION_TOKEN_NOT_FOUND"});
                        } else if (response.status == 403) {
                            $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_WRONG_CREDENTIALS"});
                        } else {
                            $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_UNKNOWN_TRY_AGAIN"});
                        } 
                        $scope.login.working = false;
                    } else {
                        console.log(response);
                        $scope.alerts = [];
                        $timeout( function() {
                           smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/userInvitation/?select=customer&type:equals=customer&status:equals=pending", {onErrorDoNotRedirect:true}).then(function (re) {
                            console.log("got invitations " , re);
                            angular.forEach(re.data.result, function (invitation) {
                                notificationService.registerNotification('invitation', 'NOTIFICATION_MESSAGE_INVITATION', invitation, {customerName:invitation.customer.name});
                            });

                        }, function (error) {
                        });
                       }, 200);

                        
                            $state.go(stwoGlobal.stateAfterLogin ? stwoGlobal.stateAfterLogin : "secure.dashboard");


                    }
		}, function(response) {
                    $scope.login.working = false;
                    if (response.status == 402) {
                        $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_GETTING_INFO"});
                    } else if (response.status == 403) {
                        $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_WRONG_CREDENTIALS"});
                    } else {
                        $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_UNKNOWN"});
                    }
		});
	}
	
	$scope.doLogin = function() {
            $scope.alerts = [];
            console.log("user: " + $scope.user);
            if (!$scope.user || !$scope.user.username) {
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_MISSING_USERNAME"});
                    return;
            }
            
            if ($scope.login.renewPassword) {
                
                if (!$scope.user.passwordNew || $scope.user.passwordNew.length === 0 || $scope.user.passwordNew !== $scope.user.passwordNewRepeat) {
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_NEW_PASSWORD_ERROR"});
                    return;
                }
                
            }


            if (!$scope.user.password) {
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_MISSING_PASSWORD"});
                    return;
            }
            $scope.working = true;

            var newUserInfo = {username: $scope.user.username.toLowerCase(), password: $scope.user.password, replacementPassword: $scope.user.passwordNew, persist: $scope.login.rememberLogin};
            var r = smarttrackerService.login(newUserInfo, $scope.login.renewPassword).then(function (response) {

                $scope.selectUser(newUserInfo.username);
                $scope.login.renewPassword = false;
            }, function(response) {
                $scope.working = false;
                if (response.status == 402) {
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_WRONG_CREDENTIALS"});
                } else if (response.status == 403) {
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_WRONG_CREDENTIALS"});
                } else if (response.status == 406) {
                    $scope.alerts.push({type: "warning", textToTranslate:"LOGIN_ERROR_MUST_RENEW_PASSWORD"});
                    $scope.login.renewPassword = true;
                } else {	
                    $scope.alerts.push({type: "danger", textToTranslate:"LOGIN_ERROR_UNKNOWN"});
                }
            });
	}

    if ($stateParams.username && $stateParams.password) {
        $scope.user.username = $stateParams.username;
        $scope.user.password = $stateParams.password;
        $scope.doLogin();
    }

    /*var cookieNotice = localStorage.getItem('cookieNotice');

    if (cookieNotice === null) {
        $scope.showCookieNotice = true;
        localStorage.setItem("cookieNotice", "false");
    }
    else if (cookieNotice == 'true') {
        $scope.showCookieNotice = true;
    }
    else {
        $scope.showCookieNotice = false;
    }
    $scope.hideCookieNotice = function () {
        if (!$scope.showCookieNotice) {
            $scope.showCookieNotice = true;
            localStorage.setItem("cookieNotice", "true");
        }
        else {
            $scope.showCookieNotice = false;
            localStorage.setItem("cookieNotice", "false");
        }
    };*/

    $scope.DemoLogin = function() {
        $scope.user.username = "demo@x-guard.nl";
        $scope.user.password = "demo";
        $scope.doLogin();
    }
    
});

angular.module('stwo.glue').controller('NotificationController', function ($scope, notificationService) {
	
	$scope.notifications = notificationService.undismissed();
	$scope.notificationsChanged = notificationService.changed;
    console.log($scope.notifications)

    notificationService.audio.snoozed = true;
    
    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.removed", function() {
        $scope.notifications = notificationService.undismissed();
    })
});
angular.module('stwo.dashboard', ["stwo.glue"])
    .config(function($stateProvider, $urlRouterProvider, moduleStoreProvider) {

        moduleStoreProvider.registerModule({
            name: "dashboard",
            links: [{
                    name:"DASHBOARD",
                    category: "navigation",
                    icon: "fa fa-tachometer",
                    sref: "secure.dashboard",
                    sort: 5,
                    color: "success",
                    controllers: ["DashboardController"]
                }]
        });

        $stateProvider
            .state("secure.dashboard",
                {
                    url: "/dashboard",
                    templateUrl: "glue/dashboard/dashboard.html",
                    controller: "DashboardController"
                })
    });
	
	
angular.module('stwo.dashboard').controller('DashboardController', function ($scope, $state, notificationService, moduleStore) {
    $scope.notifications = notificationService.undismissed();
    $scope.notificationsChanged = notificationService.changed;

    $scope.$watch("notificationsChanged.dismissed + notificationsChanged.added + notificationsChanged.removed", function() {
        $scope.notifications = notificationService.undismissed();
    })
    
    $scope.linkClicked = function(link) {
        if (link.stateParams) {
            $state.go(link.sref.split("(")[0], link.stateParams);
        } else {
            $state.go(link.sref);
        }
    }
    
});
/**
 * angular-ui-router state derived menu, nav, navbar, tab and other navigation tools
 * @version v0.2.1-dev-2014-10-30
 * @link https://github.com/nitintutlani/angular-ui-router-menus
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
!function(a,b){"use strict";function c(a){var b=a.replace(/[.+^$()|{}]/g,function(a,b,c){return"\\"===c[b-1]?a:"\\"+a});return b=b.replace(/[?*]/g,function(a,b,c){return"\\"===c[b-1]?a:"?"===a?".":".*"}),b=b.replace(/\\([dDsSwWtrnvfbB0cxu])/g,"$1"),"^"+b+"$"}function d(a){var b=[];if(g(a)&&(a=a.split(" ")),h(a))for(var d=0;d<a.length;d++)b.push(c(a[d]));return b}function e(a,b){if(h(a))for(var c=0;c<a.length;c++)if(b.match(a[c]))return!0;return!1}var f=b.isDefined,g=(b.isFunction,b.isString),h=(b.isObject,b.isArray),i=b.forEach,j=(b.extend,b.copy,b.equals,b.noop,b.module("ui.router.menus",["ng","ui.router"]));j.directive("menus",["$menus",function(a){return{link:{restrict:"EA",scope:{menus:"=",type:"@",include:"@",tag:"@"},pre:function(b,c,d){var e={};f(d.type)&&(e.type=d.type),f(d.include)&&(e.include=d.include),f(d.tag)&&(e.tag=d.tag),b[d.menus]=a.get(e)}}}}]),j.service("$menus",["$state",function(a){function b(a){if(!a.menu)return null;var b;return"string"==typeof a.menu?b={name:a.menu,state:a}:(b=a.menu,b.state=a),b}var c;this.findMenu=function(a){for(var b=0;b<c.length;b++)if(a===c[b].state.name)return c[b];return null},this.parent=function(a){var b=this.findMenu(a);if(b){if(f(b.state.parent)&&b.state.parent)return this.findMenu(b.state.parent);var c=/^(.+)\.[^.]+$/.exec(b.state.name);return c?this.findMenu(c[1]):null}return null},this.findByParent=function(a){var b=this,d=c.filter(function(c){var d=b.parent(c.state.name);return!!d&&a===d.state.name});return d},this.getTree=function(a){var b,d=this;return b=a?this.findByParent(a.state.name):c.filter(function(a){return!d.parent(a.state.name)}),i(b,function(a){a.children=d.getTree(a),a.hasChild=f(a.children)&&h(a.children)?!!a.children.length:!1}),b},this.get=function(g){g=g||{},c=[];var h=a.get(),j=g.include||null;j&&(j=d(j),h=h.filter(function(a){return e(j,a.name)}));var k=g.tag||null;k&&(k=d(k)),i(h,function(a){var d=b(a);d&&(k?f(d.tag)&&e(k,d.tag)&&c.push(d):c.push(d))});var l=g.type||"list";return"tree"===l?this.getTree():c}}])}(window,window.angular);
//# sourceMappingURL=stwo_app-glue.js.map